export default "__VITE_ASSET__CTUE1dLv__"